import { isEmpty, isUndefined, omitBy } from 'lodash';

import { loadMyRuns } from '@neptune/home-page-business-logic';
import { rejectActivation } from '@neptune/shared/routing-business-logic';
import { AppRoute, RouterSimpleState, RouterStateParams } from '@neptune/shared/routing-domain';

import { getMyRunsEnabled } from 'common/featureFlag';

const myRunsRoute: AppRoute = {
  name: 'user-my-runs',
  path: '/-/my-runs',
  onlyLoggedUser: true,
  canActivate: () => (toState) => {
    if (!getMyRunsEnabled()) {
      return rejectActivation({
        name: 'home',
        params: {},
      });
    }

    const { params } = toState;
    const myRunsState = loadMyRuns();

    const paramsToApply: RouterStateParams[] = [];

    const applyParams = (params: RouterStateParams) => {
      if (!isEmpty(omitBy(params, isUndefined))) {
        paramsToApply.push(params);
      }
    };

    if (params.experimentsOnly === undefined && myRunsState.experimentsOnly !== undefined) {
      applyParams({ experimentsOnly: myRunsState.experimentsOnly });
    }

    if (
      (params.sortDirection === undefined ||
        params.sortBy === undefined ||
        params.sortFieldType === undefined) &&
      myRunsState.sortDirection !== undefined &&
      myRunsState.sortBy !== undefined &&
      myRunsState.sortFieldType !== undefined
    ) {
      applyParams(myRunsState);
    }

    if (!isEmpty(paramsToApply)) {
      const targetState: RouterSimpleState = {
        name: 'user-my-runs',
        params: Object.assign({}, toState.params, ...paramsToApply),
      };
      return rejectActivation(targetState);
    }

    return true;
  },
};

export const homePageRoutes = [myRunsRoute];
